/*
 * @Description:
 * @Author: Leyton
 * @LastEditors: Leyton
 * @LastEditTime: 2022-08-02 11:23:12
 * @FilePath: /91qs_answer_frontpro/src/pages/slider/BaseSlider/index.js
 */
import { contexData } from "@/store";
import { StarFilled } from "@ant-design/icons";
import { Popover } from "antd";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { isEmpty } from "lodash";
import React, { useContext, useEffect, useState } from "react";
// import "./index.less";

function isOverflown(element) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

const DoubleQuestionPhone = ({ info, answer, changeAnswer }) => {
  const [value, setValue] = useState({});
  const [initilalized, setInitialized] = useState(false);

  const [topVal, setTopVal] = useState({})

  const { infoContex } = useContext(contexData);
  const type = info.preferences.childPrefer.optionForm;

  const onChange = (point, child, negtive = false) => {
    const { id } = child;
    setValue((old) => ({ ...old, [id]: point }));
    const option = child.options.find(
      (o) => o.point === (negtive ? -point : point)
    );
    if (!isEmpty(option)) {
      setInitialized(true);
      changeAnswer({ ...answer[info.id], [id]: { [option.id]: null } });
    }
  };

  useEffect(() => {
    if (!isEmpty(answer) && !initilalized) {
      try {
        const obj = answer[info.id] || answer;
        const keys = Object.keys(obj);
        const v = {};
        for (let i = 0; i < keys.length; i++) {
          const cid = keys[i];
          const [oid] = Object.keys(obj[cid]);
          const opt = info.childs
            .find((c) => c.id === cid)
            ?.options.find((o) => o.id === oid);
          const nCondition = info.optionReverse === 2 && type === 0;
          if (opt) v[cid] = nCondition ? -opt.point : opt.point;
        }
        setValue(v);
      } catch (error) {
        console.log(error.message);
      }
    }
  }, [answer, info]);

  useEffect(() => {
    try {
      const handles = document.getElementsByClassName("ant-slider-handle");
      for (let index = 0; index < handles.length; index++) {
        const element = handles[index];

        element.style.borderColor = infoContex.themeColor;
      }

      const tracks = document.getElementsByClassName("ant-slider-track");
      for (let index = 0; index < tracks.length; index++) {
        const element = tracks[index];

        element.style.backgroundColor = infoContex.themeColor;
      }
    } catch (error) { }
  }, [infoContex.themeColor]);

  useEffect(() => {
    if (type !== 0) {
      try {
        info.childs.map((child) => {
          const ele = document.getElementById("star" + child.id);
          const b = isOverflown(ele);
          if (b) {
            ele.style.transform = "scale(0.9)";
          }
        });
      } catch (error) { }
    }
  });

  useEffect(() => {
    const interval = setInterval(() => {
      try {
        const elements = document.getElementsByClassName("ant-tooltip-inner");
        Array.from(elements).forEach((ele) => {
          ele.innerHTML = Math.abs(Number(ele.innerHTML));
        });
      } catch (error) { }
    }, 10);
    return () => {
      clearInterval(interval);
    };
  }, []);
  console.log(111111);

  if (true) {
    // 标尺
    window.history.pushState(null, null, document.URL);

    if (info.optionReverse === 2) {
      const marks = {};
      info.options.map((o, i) => {
        marks[-o.point] = (
          <p
            style={{
              wordBreak: "break-word",
              lineHeight: "1.1em",
              width:
                o.description.replace(/<[^>]+>/g, "").length > 1 ? "3em" : 0,
            }}
            dangerouslySetInnerHTML={{ __html: o.description }}
          ></p>
        );
      });
      return (
        <>
          {info.childs.map((child) => {
            if (child.hide) return [];
            return (
              <div key={child.id}>
                <div
                  style={{
                    paddingLeft: 20,
                    color: infoContex?.preferences?.sonColour,
                  }}
                  dangerouslySetInnerHTML={{ __html: child.description }}
                />
                <br />
                <div
                  className="slider"
                  style={{
                    padding: "0 " + (window.innerWidth < 500 ? "20px" : "60px"),
                  }}
                >
                  <Slider
                    marks={marks}
                    value={value[child.id]}
                    defaultValue={value[child.id]}
                    onChange={(value) => onChange(value, child, true)}
                    min={-Math.max(...child.options.map((a) => a.point))}
                    max={-Math.min(...child.options.map((a) => a.point))}
                    draggableTrack
                  />
                </div>
                {info.options[0].description.replace(/<[^>]+>/g, "").length >
                  5 ? (
                  <>
                    <br />
                    <br />
                    <br />
                    <br />
                  </>
                ) : (
                  <>
                    <br />
                    <br />
                  </>
                )}
              </div>
            );
          })}
        </>
      );
    }

    const marks = {};

    info.options.map((o, i) => {
      marks[o.point] = <div dangerouslySetInnerHTML={{ __html: (o.description) }}></div>
    });

    const getDesc = (dataSrc, index) => {
      const pattern = /<([^>]+)>======<\/\1>/g;
      const pattern1 = /======/g;
      const replaceStr = "<p>======</p>";
      let newStr = '';
      if (dataSrc.match(pattern)) {
        const newDescription = dataSrc.replace(pattern, replaceStr);
        newStr = newDescription.split(replaceStr)[index];
      } else if (dataSrc.match(pattern1)) {
        const newDescription = dataSrc.replace(pattern1, replaceStr);
        newStr = newDescription.split(replaceStr)[index];
      } else {
        newStr = index === 0 ? dataSrc : ''
      }
      return newStr;
    }


    return (
      <>
        {info.childs.map((child, index) => {
          if (child.hide) return [];
          return (
            <div key={child.id} style={{
              paddingTop: index == 0 ? '0px' : "80px",
              paddingBottom: index == info.childs.length - 1 ? 100 : 0
            }}>
              {!!index && <div style={{ borderTop: "1px dashed #ccc" }}>&nbsp;</div>}
              <div style={{ display: "flex",    justifyContent: "space-between",    marginBottom: -10 }}>
                <div
                  style={{
                    width:100,
                    marginRight: 10,
                    color: infoContex?.preferences?.sonColour,
                  }}
                  dangerouslySetInnerHTML={{ __html: getDesc(child.description, 0) }}
                />
                <div
                  style={{
                    marginLeft: 10,
                    width:100,
                    color: infoContex?.preferences?.sonColour,
                  }}
                  dangerouslySetInnerHTML={{ __html: getDesc(child.description, 1) }}
                />
              </div>
              <br />
              <div
                className="slider"
                style={{
                  padding: "0 " + (window.innerWidth < 500 ? "20px" : "60px"),
                  position: "relative"
                }}
              >
                <Slider
                  marks={marks}
                  step={null}

                  handleRender={(node, props) => {
                    // setTopVal(node.props.style)
                    return <div style={{}}>
                      <div
                        style={{
                          background: "#000000bf",
                          position: 'absolute',
                          top: -30,
                          width: '30px',
                          textAlign: 'center',
                          color: "#fff",
                          display:"none",
                          ...node.props.style
                        }}
                      >
                        {JSON.stringify(value[child.id])}
                      </div>
                      {node}</div>

                  }}
                  // reverse
                  value={value[child.id]}
                  defaultValue={value[child.id]}
                  onChange={(value) => onChange(value, child)}
                  min={info.options[0].point}
                  max={info.options[info.options.length - 1].point}
                  draggableTrack
                />
                {/* <div  style={{ borderBottom: "1px solid", height:30}} ></div> */}

              </div>
              <style>{`
              .rc-slider-mark-text{
                width: 50px;
              }
              `}


              </style>
              {/* {    info.options[0].description.replace(/<[^>]+>/g, "").length >
              5 ? (
                <>
                  <div style={{ height:'80px'}}></div>
                </>
              ) : (
                <>
                   <div style={{ height:'40px'}}></div>
                </>
              )} */}
            </div>
          );
        })}
      </>
    );
  }
};

export default DoubleQuestionPhone;
// 判断是否为移动设备
function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
